'use client'

import React, { useState } from 'react'
import Header from '@/components/header/Header'
// import logoMain from '@/assets/img/logo-main.svg'
import logoMain from '@/assets/img/dark-vers.svg'
import MainWelcome from '@/components/main/MainWelcome'
import Footer from '@/components/Footer/Footer'
import TextRing from '@/components/TextRing'
import MainScene, { ErrorScene } from '@/components/MainScene/MainScene'
import { useDispatch } from 'react-redux'
import { setFooterTab } from '@/redux/features/filterSlice'

const notFoundData = {
    title: 'Ошибка 404',
    description:
        'К сожалению, страница не найдена. Возможно, ее удалили или вы перешли по ссылке, в которой была допущена ошибка. Попробуйте вернуться на главную или напишите нам.',
    btn: {
        content: 'На главную',
        link: '/'
    },
    btn2: {
        content: 'Связаться с нами',
        link: '/not-found/#contact'
    }
}

const errorData = {
    title: 'Ошибка',
    description:
        'Что то пошло не так. Попробуйте вернуться на главную или напишите нам.',
    btn: {
        content: 'На главную',
        link: '/'
    },
    btn2: {
        content: 'Связаться с нами',
        link: '/not-found/#contact'
    }
}

const NotFoundModule = ({ notFound = true }: { notFound?: boolean }) => {
    const dispatch = useDispatch()
    const [hoverItem, setHoverItem] = useState<number>(0)

    const scrollToChapter = chapterId => {
        const element = document.getElementById(chapterId)

        dispatch(setFooterTab(3))

        if (element) {
            element.scrollIntoView({ behavior: 'smooth' })
        }
    }

    return (
        <main className='main'>
            <Header
                burgerBg='linear-gradient(180deg, #3156A8 21.87%, #2D3079 108.55%)'
            />
            <div className='container'>
                
                    {/* <MainScene
                        hoverItem={hoverItem}
                        setHoverItem={setHoverItem}
                        styles={{ height: '100vh', width: '100%', filter: 'saturate(70%)' }}
                    /> */}
                    <div
                        style={{
                            overflow: 'hidden',
                            height: 'max(90dvh, 500px)',
                            width: "1280px",
                            right: 50,
                            display: "flex",
                            justifyContent: "flex-end",
                            position: 'absolute',
                            zIndex: 5
                        }}
                    >
                        <ErrorScene
                            hoverItem={hoverItem}
                            setHoverItem={setHoverItem}
                            styles={{ height: '100vh', width: '100%', filter: 'saturate(70%)' }}
                        />
                    
                </div>

                <MainWelcome
                    data={notFound === true ? notFoundData : errorData}
                    onClickSecond={() => scrollToChapter('contact')}
                />
            </div>
            <Footer />
        </main>
    )
}

export default NotFoundModule
